var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"beamlines"},[_c('IDBeamline',{staticClass:"id"}),_c('BMBeamline',{staticClass:"bm"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }